module.exports = __webpack_public_path__ + "img/base-regionsearch-d5324536.png";